import { Route, Switch, useLocation } from 'react-router-dom'
import Signup from './components/signup';

// All Components Pages
import Header from './components/header/index';
import About from './components/about';
import Contact from './components/contact';
import Home from './components/home';
import Login from './components/login';

// import Signup from './components/signup';
import Cart from './components/cart';
import Order from './components/order';
import { useEffect, useState } from 'react';
import './style/shared.css';
import { connect } from 'react-redux';
import { getUser, getBasicCart } from './actions';
import  Footer from './components/footer';
import OrderStatus from './components/order/orderStatus';
import Error from './components/Error';
import BecomeAPartner from './components/BecomeAPartner';
import {refreshTheme } from './actions';
// Services
import Services from './components/Services'

// PrivateRoute and Public Route
import PublicRoute from './routes/PublicRoute';
import PrivateRoute from './routes/PrivateRoute'
import LoginFooter from './components/login/LoginFooter'


const App = (props) => {
    const pathname = useLocation().pathname
    const [navColor, setNavColor] = useState('transparent')
    const [navMargin, setNavMargin] = useState(false)
    console.log(pathname)
    const { getUser, getBasicCart, theme, refreshTheme } = props
    useEffect(() => {
        // get current User Data if available and login user else anonymous user
        getUser();
        // get Basic cart on every page to show update cart Count
        getBasicCart();
        refreshTheme();
        
        if (pathname === '/login' 
            || pathname === '/login/' 
            || pathname === '/login/signup' 
            || pathname === '/login/signup/' 
            || pathname === '/cart' 
            || pathname === '/cart/' 
            || pathname === "/about" 
            || pathname === "/about/"
            || pathname === "/order" 
            || pathname === "/order/" 
            || pathname === "/contact" 
            || pathname === "/contact/" 
            || pathname === "/become-a-partner" 
            || pathname === "/become-a-partner/" 
            || pathname.match(/^\/order\/ORD[a-zA-Z0-9]{18}/)){

            let color = window.getComputedStyle(document.body).getPropertyValue('--main')
            const fallback_color = theme === "blue" ? "rgb(18, 35, 46)" : theme === "default" ? "rgb(26, 26, 26)" : "rgb(221, 175, 148)"
            setNavColor(color || fallback_color)
            setNavMargin(true)
        }
        else{
            setNavColor('transparent')
            setNavMargin(false)
        }
    }, [pathname, getUser, getBasicCart, theme, refreshTheme, navColor])
    return(  
        <>
            {navMargin ? <div style={{width: '100%', height: '75px'}}></div> : null}
            <Header navColor={navColor} setNavColor={setNavColor}/>
            {!props.login && <Signup />}
            <Switch>
                <Route component={Home} path="/" exact/>
                <Route component={BecomeAPartner} path="/become-a-partner" exact/>
                <Route component={Services} path="/services/:category(electrician|plumber|carpenter|cleaner|painter|pest-control|ac-service-repair|appliance-repair)/:afzal?" exact/>
                <Route component={About} path="/about" exact/>
                <Route component={Contact} path="/contact" exact/>
                {/* <Route component={Login} path="/login/:pathParam(signup)?" exact/> */}
                <PublicRoute component={Login} path="/login/:pathParam(signup)?" exact />
                <Route component={Cart} path="/cart" exact/>
                {/* <Route component={Order} path="/order" exact/> */}
                <PrivateRoute component={Order} path="/order" exact />
                {/* <Route path="/order/:order_id(ORD[a-zA-Z0-9]{18})" component={OrderStatus}/> */}
                <PrivateRoute component={OrderStatus} path="/order/:order_id(ORD[a-zA-Z0-9]{18})" />
                <Route component={Error} path="*" /> 
            </Switch>
            {pathname === "/login" ? <LoginFooter /> : <Footer />}
        </>
    )
}
const mapStateToProps = (state) => {
    return {
        theme: state.theme
    }
}
export default connect(mapStateToProps , { getUser, getBasicCart, refreshTheme })(App);